module.exports = __webpack_public_path__ + "img/insights_chart.59d81610.svg";